import React from "react";

import classNames from "classnames";

import { DropdownPortalMenu } from "src/app/components/DropdownPortal";

interface MenuOverlayProps {
  handleClick?: () => void;
  showEditOptionPane?: boolean;
  spaceLeft?: boolean;
  className?: string;
  qaAttribute?: string;
  qaContext?: string;
}

export function MenuOverlay({
  showEditOptionPane,
  children,
  handleClick,
  spaceLeft,
  className,
  qaAttribute,
  qaContext,
}: React.PropsWithChildren<MenuOverlayProps>) {
  return (
    <DropdownPortalMenu
      className={classNames(
        {
          "dropdown__menu--left": showEditOptionPane && spaceLeft,
        },
        "select__menu",
        className,
      )}
      onClick={handleClick}
      data-qa={qaAttribute}
      data-qa-context={qaContext}
    >
      {children}
    </DropdownPortalMenu>
  );
}
